import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { ParticipantLayout } from "../../components/Layout";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { FileText } from "lucide-react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ContentPage = () => {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [contents, setContents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, [slug]);

  const fetchData = async () => {
    setLoading(true);
    try {
      // Get page info
      const pagesRes = await axios.get(`${API}/pages`);
      const foundPage = pagesRes.data.find(p => p.slug === slug);
      setPage(foundPage);

      if (foundPage) {
        // Get content for this page
        const contentsRes = await axios.get(`${API}/pages/${foundPage.id}/content`);
        setContents(contentsRes.data);
      }
    } catch (error) {
      if (error.response?.status === 403) {
        toast.error("Kein Zugriff auf diese Inhalte");
      } else {
        toast.error("Fehler beim Laden");
      }
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <ParticipantLayout>
        <div className="flex items-center justify-center h-64">
          <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
        </div>
      </ParticipantLayout>
    );
  }

  if (!page) {
    return (
      <ParticipantLayout>
        <Card className="bg-card border-border">
          <CardContent className="py-12 text-center text-muted-foreground">
            <FileText className="h-12 w-12 mx-auto mb-4 opacity-50" />
            <p>Seite nicht gefunden</p>
          </CardContent>
        </Card>
      </ParticipantLayout>
    );
  }

  return (
    <ParticipantLayout title={page.name}>
      <div className="space-y-6" data-testid={`content-page-${slug}`}>
        {contents.length === 0 ? (
          <Card className="bg-card border-border">
            <CardContent className="py-12 text-center text-muted-foreground">
              <FileText className="h-12 w-12 mx-auto mb-4 opacity-50" />
              <p>Noch keine Inhalte verfügbar</p>
              <p className="text-sm mt-2">Der Administrator wird hier bald Inhalte hinzufügen.</p>
            </CardContent>
          </Card>
        ) : (
          contents.map((content) => (
            <Card key={content.id} className="bg-card border-border">
              <CardHeader className="border-b border-border">
                <CardTitle>{content.title}</CardTitle>
              </CardHeader>
              <CardContent className="p-6">
                <div className="prose prose-invert max-w-none whitespace-pre-wrap">
                  {content.content || <span className="text-muted-foreground">Kein Inhalt</span>}
                </div>
              </CardContent>
            </Card>
          ))
        )}
      </div>
    </ParticipantLayout>
  );
};

export default ContentPage;
